import { Reveal } from "@/components/Reveal";
import { SITE } from "@/data/site";
import { Seo } from "@/components/Seo";

export default function CookiePolicy() {
  return (
    <div data-testid="cookie-policy-page">
      <Seo
        title="Cookie Policy | TopAffiliation"
        description="Informativa sull'utilizzo dei cookie tecnici e di terze parti sul sito TopAffiliation."
        path="/cookie-policy"
      />
      <section className="pt-36 md:pt-44 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal>
            <span className="eyebrow">Informativa</span>
            <h1 className="mt-5 font-heading text-4xl md:text-5xl font-extrabold">Cookie Policy</h1>
            <p className="mt-5 text-white/60">
              Questo sito utilizza i cookie tecnici e di terze parti per migliorare
              l'esperienza di navigazione.
            </p>
          </Reveal>

          <div className="prose-italia mt-10">
            <h2>Cosa sono i cookie</h2>
            <p>
              I cookie sono piccoli file di testo che i siti visitati inviano al terminale
              dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti
              alla visita successiva. I cookie servono a rendere più efficiente la fruizione
              del sito e a raccogliere informazioni statistiche in forma aggregata.
            </p>

            <h2>Tipologie di cookie utilizzati</h2>
            <ul>
              <li>
                <strong>Cookie tecnici:</strong> necessari al corretto funzionamento del sito
                e alla navigazione. Non richiedono il consenso dell'utente.
              </li>
              <li>
                <strong>Cookie analitici:</strong> utilizzati in forma aggregata per
                raccogliere informazioni sul numero di utenti e su come questi visitano il sito.
              </li>
              <li>
                <strong>Cookie di terze parti:</strong> installati da servizi esterni (ad es.
                strumenti di analisi o partner pubblicitari) e regolati dalle rispettive policy.
              </li>
            </ul>

            <h2>Gestione dei cookie</h2>
            <p>
              L'utente può gestire le preferenze relative ai cookie direttamente all'interno
              del proprio browser, impedendone l'installazione o eliminando quelli già
              memorizzati. La disabilitazione dei cookie tecnici potrebbe compromettere alcune
              funzionalità del sito.
            </p>

            <h2>Contatti</h2>
            <p>
              Per qualsiasi informazione relativa alla presente cookie policy è possibile
              scrivere a <a href={`mailto:${SITE.email}`}>{SITE.email}</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
